import { useSelector } from 'react-redux';
import useTranslation from '../../../../hooks/useTranslations';
import { selectActiveBusinessAreas } from '../../../../redux/modules/data/businessAreasSlice';
import ContentWrapper from '../../layouts/partials/ContentWrapper';
import SidebarWrapper from '../../layouts/partials/SidebarWrapper';
import BusinessAreaTile from '../partials/tiles/BusinessAreaTile';
import TileWrapper from '../partials/TileWrapper';

const HomeScreen = () => {
	const t = useTranslation();
	const activeBusinessAreas = useSelector((state) => selectActiveBusinessAreas(state));

	return (
		<>
			<SidebarWrapper title={t('webapp_home_select_ba')} hideBreadcrumb showLogo />
			<ContentWrapper classes="min-h-screen-oly-mobile-dashboard bg-oly-blue-default">
				<TileWrapper containerClasses="pt-4 lg:pt-24" tileClasses="lg:w-1/3">
					{activeBusinessAreas.map((businessArea) => (
						<BusinessAreaTile key={businessArea.id} businessArea={businessArea} />
					))}
				</TileWrapper>
			</ContentWrapper>
		</>
	);
};

export default HomeScreen;
